import React from 'react';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../components/charts/BarChart';
import { useStyles } from './styles';

interface IAvailabilityChart {
  dfData: number[];
  kpiLabels: string[];
  width?: string | number;
  height?: string | number;
  showTitle?: boolean;
  margin?: number;
}

const AvailabilityChart: React.FC<IAvailabilityChart> = ({
  dfData,
  kpiLabels,
  width,
  height,
  showTitle = false,
  margin,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <BarChart
        title={showTitle ? t('screens:availability.title') : undefined}
        showLegend={false}
        series={{
          name: `${t('screens:availability.physicalAvailability')} (%)`,
          data: dfData,
        }}
        categories={kpiLabels}
        width={width}
        height={height}
        unit="%"
        margin={margin}
      />
    </div>
  );
};

export default AvailabilityChart;
